(() => {
	if (window.faqAccordionSettingsInitialized) {
		return;
	}

	window.faqAccordionSettingsInitialized = true;

	const selectors = {
		container: '[data-single-open="true"]',
		item: '.js-accordion-item',
		control: '.js-accordion-control',
		content: '.js-accordion-content',
		inner: '.js-accordion-inner',
	};

	const activeClass = 'is-active';

	function getFocusableElements(target) {
		if (window.themeCore?.utils?.focusable) {
			return window.themeCore.utils.focusable(target);
		}

		return [...target.querySelectorAll('a, button, input, textarea, select, [tabindex]')].filter(
			(element) => element.tabIndex !== -1 && !element.disabled
		);
	}

	function unsetTabIndexOnTarget(target) {
		getFocusableElements(target).forEach((element) => {
			element.setAttribute('tabindex', -1);
		});
	}

	function collapseItem(element) {
		const elementContent = element.querySelector(selectors.content);
		const inner = element.querySelector(selectors.inner);
		const control = element.querySelector(selectors.control);

		if (!elementContent || !inner || !control) {
			return;
		}

		const innerHeight = inner.offsetHeight;
		elementContent.style.height = `${innerHeight}px`;

		setTimeout(() => {
			elementContent.style.height = '0';
		}, 0);

		unsetTabIndexOnTarget(elementContent);
		element.classList.remove(activeClass);
		control.setAttribute('aria-expanded', 'false');
	}

	function handleClick(event) {
		const control = event.target.closest(selectors.control);

		if (!control) {
			return;
		}

		const container = control.closest(selectors.container);

		if (!container) {
			return;
		}

		const item = control.closest(selectors.item);

		if (!item) {
			return;
		}

		container.querySelectorAll(selectors.item).forEach((otherItem) => {
			if (otherItem !== item && otherItem.classList.contains(activeClass)) {
				collapseItem(otherItem);
			}
		});
	}

	document.addEventListener('click', handleClick, true);
})();
